import Vue from 'vue';
import Vuex from 'vuex';
import review from './modules/review';
import upload from './modules/upload';
import reference from './modules/reference';
import reviewerScreeningVote from './modules/reviewerScreeningVote';
import reviewMember from './modules/reviewMember';
import screeningOutcome from './modules/screeningOutcome';
import reviewCriteria from './modules/reviewCriteria';
import reviewTag from './modules/reviewTag';
import fullTextPdf from './modules/fullTextPdf';
import fullTextReviewVote from './modules/fullTextReviewVote';
import fullTextReviewOutcome from './modules/fullTextReviewOutcome';
import bulkUploadFullTextPdf from './modules/bulkUploadFullTextPdf';
import dataExtractionReport from './modules/dataExtractionReport';
import dataExtractionValue from './modules/dataExtractionValue';
import dataExtractionField from './modules/dataExtractionField';
import comment from './modules/comment';
import reviewMemberInvite from './modules/reviewMemberInvite';
import user from './modules/user';
import adminActivity from './modules/adminActivity';
import uploadReferences from './modules/uploadReferences';
import revision from './modules/revision';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    review,
    upload,
    reference,
    reviewerScreeningVote,
    reviewMember,
    screeningOutcome,
    reviewCriteria,
    reviewTag,
    fullTextPdf,
    fullTextReviewVote,
    fullTextReviewOutcome,
    bulkUploadFullTextPdf,
    dataExtractionReport,
    dataExtractionValue,
    dataExtractionField,
    comment,
    reviewMemberInvite,
    user,
    adminActivity,
    uploadReferences,
    revision,
  },
});
